import Home from "./Home";

export default [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      allAccess: true,
    },
  },
];
